import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styles: []
})
export class ContactComponent implements OnInit {

  personalData:any = {}

  @Input()
  cotizador:any={};

  @Input()
  plan:any={};

  @Input()
  data:any={};

  constructor() { }

  ngOnInit() {
  }


  contact(){
    console.log(this.cotizador);
    console.log(this.plan);
    console.log(this.data);
    console.log(this.personalData);
  }


}
